var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chart-stats-table',{attrs:{"songs":_vm.songs}})}
var staticRenderFns = []

export { render, staticRenderFns }